import { SupportedLanguage } from '@novakid/ts-types';
import { createContext } from 'react';

import { getDefaultTranslations } from 'utils';
import { Texts } from 'types';

export const TranslationsContext = createContext<{ translations: Texts, language: SupportedLanguage}>({
  translations: getDefaultTranslations(),
  language: 'en',
});